<template>
    <v-dialog v-model="show" hide-overlay persistent width="300">
        <v-card color="success lighten-1" dark>
            <v-card-text>{{ text }}
                <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
  export default {
    name: 'simpleLoaderDialog',
    props: ['text', 'show'],
    data () {
      return {

      }
    }
  }
</script>

<style scoped>

</style>